import img1 from "../../images/order-history/1.png";
import img2 from "../../images/order-history/2.png";
import img3 from "../../images/order-history/3.png";
import img4 from "../../images/order-history/4.png";

const order_history = [
	{
		link: "#",
		img: img1,
		price: "$25.99",
		date: "Jun 15",
		title: "Arabic Teachers Resource Pack",
	},
	{
		link: "#",
		img: img2,
		price: "$45.00",
		date: "Jun 20",
		title: "Core English - Summary 3",
	},
	{
		link: "#",
		img: img3,
		price: "$60.00",
		date: "Jun 25",
		title: "Career Technology CCP Curriculum",
	},
	{
		link: "#",
		img: img4,
		price: "$30.30",
		date: "Jun 21",
		title: "Ma Yensua Asante Twi - Teacher's Guide 4",
	},
];

export default order_history;
